import { atom } from 'jotai'

export const formularios = atom([]);